import { Ref, useEffect, useRef, useState } from 'react'
import { Alert, FormInstance, message, Spin, Upload } from 'antd'
import { SFuncModal, SGeneralForms } from 'shj-components'
import { getEnumTamsList } from "@/services";
import { getVendorInfo, vendorInfoAttestationInfo } from "@/services/workerManagement.ts";
import { useFileUrlPrefix } from "shj-utils";
import { httpDictServ } from '@/services/customerServices';
import { isArray } from 'lodash-es';
import ImageUpload from '@/components/Upload/ImageUpload';
import { getImgRelativePath } from '@/utils';

export interface authenticationModalProp {
    title: string
    detailsData: any,
    info?: any,
    isView?: boolean,
    onclose?: any
}

export interface authenticationModalDomProp {
    onClose: any
    detailsData: any
    info?: any
    isView?: boolean
}

const AuthenticationModalDom = (props: authenticationModalDomProp) => {
    const { onClose, detailsData, isView, info } = props;
    const fileUrlPrefix = useFileUrlPrefix()
    const formRef = useRef<Ref<any> & { onFormRef: () => FormInstance }>(null);
    const [data, setData] = useState<Record<string, any>>({
        principal1: true,
    })
    const [confirmLoading, setConfirmLoading] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false);
    const [errorMsg, setErrorMsg]: any = useState("");
    const initFn = () => {
        setLoading(true)
            getVendorInfo({ id:info.id, labelFlag: true})
                .then((res: any) => {
                    const obj_ = {
                        ...delFileUrl(["identityFile", "sealFile", 'siagnApplication', 'financialSealFile', 'idCardFaceFile', 'idCardBackFile'], res, false, fileUrlPrefix)
                    }
                    setData(obj_)
                    setLoading(false)
                })
                .catch(() => {
                    setLoading(false)
                })
    }

    const getTaxRateList = () => {
        return httpDictServ({ parentKey: 'taxRate', enable: 1, }).then((response: any) => {
            return response;
        });
    };
    const getBillingTypeList = () => {
        return getEnumTamsList('com.shj.saas.tams.enums.BillingTypeEnum').then((response: any) => {
            return response;
        });
    };
    const httpOptionsFn = (): Promise<Record<string, any>> => {
        return new Promise(async (resolve) => {
            const taxRateList = await getTaxRateList();
            const billingTypeList = await getBillingTypeList();
            if (!data?.id) {
                formRef.current?.onFormRef()?.setFieldsValue({ billingType: 'plainInvoice' })
            }
            resolve({
                taxRateList,
                billingTypeList
            });
        });
    };


    useEffect(() => {
        initFn()
    }, [detailsData])
    const delFileUrl = (arrKeyName, data, isSubmit = true, fileUrlPrefix) => {
        let formOBj = {
            ...data
        };
        arrKeyName.forEach((key) => {
            if (data[key]) {
                //显示
                if (!isSubmit) {
                    if (!isArray(data[key])) {
                        formOBj[key] = [];
                        let itemArr = data[key].split(',');
                        formOBj[key] = isArray(itemArr) && itemArr.length && itemArr.map((item, index) => {
                            return {
                                uid: index,
                                name: item,
                                url: fileUrlPrefix + item,
                                relativePath: item,
                            }
                        })
                    }
                    //提交
                } else {
                    if (isArray(data[key])) {
                        formOBj[key] = getImgRelativePath(data[key][0]);
                    }
                }
            }
        })
        return formOBj;
    }
    const beforeUpload = (file: any) => {
        if ((file.type || '').startsWith('image')) {
            if (!file.name.endsWith('.jpg') && !file.name.endsWith('.bmp') && !file.name.endsWith('.png') && !file.name.endsWith('.jpeg')) {
                message.error('图片必须是jpg/jpeg/png/bmp格式')
                return Upload.LIST_IGNORE
            }
            return true
        }
        message.error('只能上传图片')
        return Upload.LIST_IGNORE
    }
    // 提交
    const onFinish = () => {
        formRef.current?.onFormRef()?.validateFields().then((values) => {
            setConfirmLoading(true)
            let obj_ = {
                ...data,
                ...delFileUrl(["identityFile", "sealFile", 'siagnApplication', 'financialSealFile', 'idCardFaceFile', 'idCardBackFile'], values, true, fileUrlPrefix),
            }
            if (info?.account) {
                obj_ = {
                    ...info,
                    ...obj_,
                }
            }
            obj_.esignFlag = 1;
            vendorInfoAttestationInfo({
                ...obj_
            }).then((res: any) => {
                message.success(res?.message || '操作成功');
                setConfirmLoading(false);
                onClose(true)
            }).catch(() => {
                setConfirmLoading(false);
            })
        })
    }

    return (
        <SFuncModal.Content
            onCancel={onClose}
            onOk={onFinish}
            footer={!!isView}
            confirmLoading={confirmLoading}
        >
            <Spin spinning={loading} tip={'数据加载中...'}>
                <SGeneralForms
                    detailsData={data}
                    isFooterBtn={false}
                    isDetail={true}
                    footerAlign="right"
                    configs={[
                        {
                            title: '基本信息',
                            formItem: [
                                { name: 'id', label: 'id', isHideItem: true },
                                {
                                    spanCol: 24,
                                    isHideItem: !errorMsg,
                                    customRender: (
                                        <div style={{ marginBottom: 10 }}>
                                            <Alert message="申请错误描述xxxxxx。" type="error"
                                                showIcon />
                                        </div>
                                    )
                                },
                                {
                                    name: 'vendorCode',
                                    label: '账号',
                                    spanCol: 8,
                                    comConfig: {
                                        disabled: true,
                                    }
                                },
                                {
                                    name: 'name',
                                    label: '承包商名称',
                                    spanCol: 8,
                                    comConfig: {
                                        disabled: true,
                                    },
                                },
                                {
                                    name: 'businessLicence',
                                    label: '信用代码',
                                    spanCol: 8,
                                    isHideItem: detailsData?.typeCode !== "enterprise",
                                    comConfig: {
                                        disabled: true,
                                    }
                                },
                                {
                                    name: 'corporateName',
                                    label: '法人',
                                    spanCol: 8,
                                    comConfig: {
                                        disabled: true,
                                    }
                                },
                                {
                                    name: 'corporateCode',
                                    label: '法人证件号',
                                    spanCol: 8,
                                    comConfig: {
                                        disabled: true,
                                    }
                                },
                                {
                                    name: 'emails',
                                    label: '邮箱',
                                    spanCol: 8,
                                    comConfig: {
                                        disabled: true,
                                    }
                                },
                                {
                                    name: 'phone',
                                    label: '电话',
                                    spanCol: 8,
                                    comConfig: {
                                        disabled: true,
                                    }
                                },
                                {
                                    name: 'address',
                                    label: '地址',
                                    spanCol: 16,
                                    comConfig: {
                                        disabled: true,
                                    }
                                },
                            ],
                        },
                    ]}
                />
                <SGeneralForms
                    detailsData={data}
                    httpOptionsFn={httpOptionsFn}
                    isFooterBtn={false}
                    ref={formRef}
                    configs={[
                        {
                            title: '认证资料',
                            formItem: [
                                {
                                    name: 'idCardBackFile',
                                    htmlFor: 'idCardBackFile',
                                    label: '身份证人面像',
                                    required: true,
                                    isHideItem: detailsData?.typeCode == "enterprise",
                                    spanCol: 8,
                                    comConfig: {
                                        disabled: !!isView,
                                    },
                                    children: () => <ImageUpload limit={1} disabled={!!isView} accept={'image/png,image/bmp,image/jpeg,image/jpg'} beforeUpload={beforeUpload}/>
                                },
                                {
                                    name: 'idCardFaceFile',
                                    htmlFor: 'idCardFaceFile',
                                    label: '身份证国徽面',
                                    required: true,
                                    isHideItem: detailsData?.typeCode == "enterprise",
                                    spanCol: 8,
                                    comConfig: {
                                        disabled: !!isView,
                                    },
                                    children: () => <ImageUpload limit={1} disabled={!!isView} accept={'image/png,image/bmp,image/jpeg,image/jpg'} beforeUpload={beforeUpload}/>
                                },
                                {
                                    name: 'identityFile',
                                    htmlFor: 'identityFile',
                                    label: '营业执照',
                                    required: true,
                                    isHideItem: detailsData?.typeCode === "personal",
                                    spanCol: 12,
                                    comConfig: {
                                        disabled: !!isView,
                                    },
                                    children: () => <ImageUpload limit={1} disabled={!!isView} accept={'image/png,image/bmp,image/jpeg,image/jpg'} beforeUpload={beforeUpload}/>
                                },
                                {
                                    name: 'sealFile',
                                    htmlFor: 'sealFile',
                                    label: '印章',
                                    required: true,
                                    isHideItem: detailsData?.typeCode === "personal",
                                    spanCol: 12,
                                    comConfig: {
                                        disabled: !!isView,
                                    },
                                    children: () => <ImageUpload limit={1} disabled={!!isView} accept={'image/png,image/bmp,image/jpeg,image/jpg'} beforeUpload={beforeUpload}/>
                                },
                                {
                                    name: 'siagnApplication',
                                    htmlFor: 'siagnApplication',
                                    label: '授权书',
                                    required: true,
                                    spanCol: 12,
                                    comConfig: {
                                        disabled: !!isView,
                                    },
                                    children: () => <ImageUpload limit={1} disabled={!!isView} accept={'image/png,image/bmp,image/jpeg,image/jpg'} beforeUpload={beforeUpload}/>
                                },
                                {
                                    name: 'financialSealFile',
                                    htmlFor: 'financialSealFile',
                                    label: '财务印章',
                                    isHideItem: detailsData?.typeCode === "personal",
                                    required: true,
                                    spanCol: 12,
                                    comConfig: {
                                        disabled: !!isView,
                                    },
                                    children: () => <ImageUpload limit={1} disabled={!!isView} accept={'image/png,image/bmp,image/jpeg,image/jpg'} beforeUpload={beforeUpload}/>
                                },
                            ],
                        },
                    ]}
                />
            </Spin>
        </SFuncModal.Content>
    )
}

export function authenticationModal(props: authenticationModalProp) {
    const { detailsData, title, onclose, isView, info } = props
    let dialog: any = 0;
    const onClose = (data) => {
        (dialog as any)?.destroy();
        onclose && onclose(data)
    }
    dialog = SFuncModal({
        width: 800,
        maskClosable: false,
        vanish: true,
        closable: isView,
        title,
        content: (
            <AuthenticationModalDom 
            onClose={onClose}
            detailsData={detailsData} isView={isView} info={info} />
        ),
    })

    return dialog
}
